<template>
  <no-auth v-if="!hasAuthorize.list && !tab"></no-auth>
  <div v-else-if="tab"></div>
  <div :class="{ 'o-card': !tab }" v-else>
    <Table
      no-card
      :title="
        !tab
          ? mainProject
            ? $t(`${name}.titleWithMainProject`, {
                mainProject: mainProject.title,
              })
            : $t(`${name}.title`)
          : ''
      "
      :description="tab ? '' : $t(`${name}.description`)"
      i18n
      :loading="getItemsLoading"
      :items="getItems(page)"
      checkable
      :status="getStatus"
      :checkValue="checkedList"
      @change:sort="SET_CHANGE_SORT"
      @change:checkedList="checkedList = $event"
      @change:selectAllWithoutPage="SET_CHECKED_ALL"
      :headers="headers"
      :page="page"
      :count="getItemCount"
      :pages="getItemPages(limit)"
      :searchValue="search"
      @change:search="setSearch"
      @change:page="setChangedPage"
      :searchPlaceholder="$t(`${name}.searchPlaceholder`)"
    >
      <template #new-button>
        <div class="u-display-flex u-width-100% u-justify-content-flex-end">
          <ExcelExport
            :fileName="`${name}-export-${date()}`"
            :fields="exportFields"
            :data="checkedList.length > 0 ? checkedList : getItems()"
          >
            <template #button="{ showExcell }">
              <Button
                @click="showExcell()"
                variant="light-success"
                class="u-margin-right-xsmall"
              >
                <i class="icofont-arrow-up"></i> {{ $t("common.export") }}
              </Button>
            </template>
          </ExcelExport>

          <router-link
            v-if="!tab && hasAuthorize.add"
            :to="{
              name: `new-${name}`,
              query: { mainProjectId: mainProject?.id },
            }"
          >
            <Button variant="light-primary"> + {{ $t(`${name}.add`) }} </Button>
          </router-link>
        </div>
      </template>
      <template #filter v-if="!noFilter">
        <ProjectFilter @change:filter="setFilter"></ProjectFilter>
      </template>
      <template #batteries="{ item }">
        <div class="u-cursor-pointer" @click="showDetail(item)">
          <div v-for="(battery, i) in item.batteryInfo" :key="i">
            <img
              v-tooltip="battery?.type"
              :src="
                require(`@/assets/images/battery-types/${battery?.type}.png`)
              "
              :alt="battery?.name"
              width="25"
            />
            <chip
              class="u-margin-left-xsmall"
              size="sm"
              :variant="
                battery.isDelete
                  ? 'warning'
                  : battery.isLocked
                  ? 'danger'
                  : 'success'
              "
            >
              <i
                :class="`icofont-${
                  battery.isDelete
                    ? 'warning'
                    : battery.isLocked
                    ? 'ui-lock'
                    : 'ui-unlock'
                }`"
              ></i>
            </chip>
            <span
              class="u-margin-left-xsmall"
              :class="{ 'u-removed-text': battery.isDelete }"
            >
              {{ battery?.name }}
            </span>
          </div>
        </div>
      </template>
      <template #name="{ item }">
        <div class="u-cursor-pointer" @click="showDetail(item)">
          <span>
            <span class="u-color-danger">{{ item.model }}</span>
          </span>
        </div>
        <div class="u-cursor-pointer" @click="showDetail(item)">
          <span> {{ item.compressorBrandInfo.title }} </span>
          <div>
            <small>
              {{ item.compressorBrandRefrigerantInfo.title }} -
              {{ item.compressorRefrigerantModelInfo.title }}
            </small>
          </div>
        </div>
      </template>
      <template #info="{ item }">
        <div>
          <Chip :variant="item.isLocked ? 'danger' : 'success'">
            <i :class="`icofont-ui-${item.isLocked ? '' : 'un'}lock`"></i>
            {{
              item.isLocked
                ? $t("common.lockedText")
                : $t("common.unlockedText")
            }}
          </Chip>
        </div>
        <div class="u-color-primary">
          <i class="icofont-calendar"></i> {{ date(item.createdDate) }}
        </div>
        <div class="u-cursor-pointer" @click="showAdminDetail(item)">
          <small>
            <i class="icofont-user"></i> {{ item.userInfo.fullname }}</small
          >
        </div>
      </template>
      <template #action="{ item }">
        <div
          class="u-display-flex u-align-items-center u-justify-content-flex-end"
        >
          <Dropdown align="right">
            <template #title>
              <div class="u-font-size-xlarge u-padding-left">
                <i class="icofont-bubble-down"></i>
              </div>
            </template>
            <template #content>
              <ul class="c-list">
                <li
                  v-if="hasAuthorize.locked"
                  @click="LOCKED_TO(item)"
                  class="c-list__item"
                  :class="{
                    'c-list__item--disabled':
                      !item.isPermission || !hasAuthorize.locked,
                  }"
                >
                  <span>
                    <i class="icofont-ui-lock u-margin-right-xsmall"></i>
                    {{ $t(`common.${item.isLocked ? "un" : ""}locked`) }}</span
                  >
                  <i class="icofont-ui-lock" v-if="!item.isPermission"></i>
                </li>
                <router-link
                  :to="{ name: `${name}-copy`, params: { projectId: item.id } }"
                >
                  <li class="c-list__item">
                    <span>
                      <i class="icofont-ui-copy u-margin-right-xsmall"></i>
                      {{ $t("common.copy") }}</span
                    >
                  </li></router-link
                >
                <component
                  :is="
                    item.isPermission && !item.isLocked && hasAuthorize.edit
                      ? 'router-link'
                      : 'span'
                  "
                  :to="{ name: `${name}-edit`, params: { projectId: item.id } }"
                >
                  <li
                    class="c-list__item"
                    :class="{
                      'c-list__item--disabled':
                        !item.isPermission ||
                        item.isLocked ||
                        !hasAuthorize.edit,
                    }"
                  >
                    <span>
                      <i class="icofont-edit u-margin-right-xsmall"></i>
                      {{ $t("common.edit") }}</span
                    >
                    <i
                      class="icofont-ui-lock"
                      v-if="!item.isPermission || item.isLocked"
                    ></i>
                  </li>
                </component>
                <router-link
                  v-if="hasAuthorize.getById"
                  :to="{
                    name: `${name}-detail`,
                    params: { projectId: item.id },
                  }"
                >
                  <li class="c-list__item">
                    <span>
                      <i class="icofont-eye u-margin-right-xsmall"></i>
                      {{ $t("common.goToDetail") }}</span
                    >
                  </li>
                </router-link>
                <router-link
                  :to="{
                    name: `new-cycle`,
                    query: {
                      projectId: item.id || null,
                      mainProjectId: item.mainProjectInfo?.id || null,
                      seriesId: item.mainProjectInfo?.seriesInfo?.id || null,
                    },
                  }"
                >
                  <li class="c-list__item">
                    <span>
                      <i class="icofont-calculator u-margin-right-xsmall"></i>
                      {{ $t("projectDetail.calculateCycle") }}</span
                    >
                  </li>
                </router-link>
                <li
                  @click="REMOVE_TO(item)"
                  class="c-list__item"
                  :class="{
                    'c-list__item--disabled':
                      !item.isPermission ||
                      item.isLocked ||
                      !hasAuthorize.delete,
                  }"
                >
                  <span>
                    <i class="icofont-trash u-margin-right-xsmall"></i>
                    {{ $t("common.remove") }}</span
                  >
                  <i
                    class="icofont-ui-lock"
                    v-if="!item.isPermission || item.isLocked"
                  ></i>
                </li>
              </ul>
            </template>
          </Dropdown>
        </div>
      </template>
    </Table>
    <LockedModal
      v-model="lockedModal.status"
      :description="$t(`${update.title}.${SET_LOCKED_DESCRIPTION()}`)"
      :okText="$t(`common.${SET_LOCKED_DESCRIPTION()}`)"
      @ok="LOCKED_ITEM"
    ></LockedModal>
    <RemoveModal @ok="REMOVE_ITEM" v-model="removeModal.status"></RemoveModal>
    <drawer v-model="showDetailModal.adminDetailStatus">
      <div v-if="showDetailModal.item">
        <AdminDrawerDetail
          :admin-id="showDetailModal?.item?.userInfo.id"
        ></AdminDrawerDetail>
      </div>
    </drawer>
    <drawer
      :title="
        $t('project.detail', {
          model: showDetailModal?.item?.model,
        })
      "
      size="full"
      v-model="showDetailModal.status"
    >
      <ProjectDrawerDetail
        :projectId="showDetailModal?.item?.id"
        :projectItem="showDetailModal?.item"
      ></ProjectDrawerDetail>
    </drawer>
  </div>
</template>

<script>
import Table from "@/components/Base/Table/index.vue";
import DateHelper from "@/helpers/date";
import { mapGetters } from "vuex";
import Button from "../Base/Button.vue";
import Chip from "../Base/Chip.vue";
import Dropdown from "../Base/Dropdown.vue";
import LockedModal from "@/components/Shared/LockedModal/index.vue";
import RemoveModal from "@/components/Shared/RemoveModal/index.vue";
import Drawer from "../Base/Drawer.vue";
import ProjectFilter from "./ProjectFilter.vue";
import ExcelExport from "../Base/ExcelExport.vue";
import Requests from "@/services/Requests";
import AdminDrawerDetail from "../Admins/AdminDrawerDetail.vue";
import ProjectDrawerDetail from "./ProjectDrawerDetail.vue";
import projectExportFields from "./projectExportFields";
import authorize from "./authorize";
export default {
  components: {
    Drawer,
    Dropdown,
    LockedModal,
    RemoveModal,
    ProjectFilter,
    ProjectDrawerDetail,
    Chip,
    Table,
    Button,
    ExcelExport,
    AdminDrawerDetail,
  },
  mixins: [projectExportFields, authorize],
  props: {
    query: {
      type: Object,
      default: () => {
        return {};
      },
    },
    noFilter: {
      type: Boolean,
      default: false,
    },
    tab: {
      type: Boolean,
      default: false,
    },
    mainProjectId: {
      type: String,
      default: "",
    },
    limit: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      name: "project",
      checkedList: [],
      showLockedModal: false,
      showRemoveModal: false,
      filter: {},
      sort: {},
      get: {
        title: "projects",
        dispatch: "getProjects",
      },
      update: {
        title: "updateProjects",
        dispatch: "updateProject",
        lockedStatus: "isLocked",
      },
      remove: {
        title: "removeProjects",
        dispatch: "removeProject",
      },
      page: 1,
      search: "",
      headers: [
        {
          col: 12,
          sm: 3,
          md: 3,
          lg: 3,
          title: "project.name",
          value: "name",
          sortable: true,
        },
        {
          col: 12,
          sm: 5,
          md: 5,
          lg: 5,
          title: "project.batteries",
          value: "batteries",
        },
        {
          col: 10,
          sm: 2,
          md: 2,
          lg: 2,
          title: "common.info",
          value: "info",
          sortable: true,
        },
        {
          col: 2,
          sm: 1,
          md: 1,
          lg: 1,
          align: "right",
          title: "common.action",
          value: "action",
        },
      ],
      removeModal: { status: false, item: {} },
      lockedModal: { status: false, item: {} },
      showDetailModal: { status: false, adminDetailStatus: false, item: null },
      mainProject: null,
    };
  },
  computed: {
    ...mapGetters({
      getItems: "getProjects",
      getItemsLoading: "getProjectsLoading",
      getItemPages: "getProjectPages",
      getItemCount: "getProjectCount",
      getActiveUser: "getActiveUser",
      getStatus: "getProjectStatus",
    }),
    exportFields() {
      if (this.getItems().length === 0) return {};
      return this.getExcelFields();
    },
  },
  methods: {
    SET_CHANGE_SORT(headers) {
      const sortedHeaders = headers.filter((item) => item.sort);
      if (sortedHeaders.length === 0) {
        this.sort = {};
        this.getItemsOfPage();
      } else {
        const sort = sortedHeaders[0];
        if (sort.sort.includes("name")) {
          const value = sort.sort.split("-")[1];
          this.sort = {
            sort: value.toUpperCase(),
            sortFilter: "ALPHABETIC",
          };
        } else if (sort.sort.includes("info")) {
          const value = sort.sort.split("-")[1];
          this.sort = {
            sort: value.toUpperCase(),
            sortFilter: "DATE",
          };
        }
        this.getItemsOfPage();
      }
    },
    async SET_CHECKED_ALL(data) {
      if (data) {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: true,
          status: true,
        });
        const response = await Requests.Project.GetAll({
          query: { page: 1, limit: this.getItemCount, search: this.search },
        });
        if (response.message === "OK") {
          console.log(response.data);

          this.checkedList = [
            ...response.data.items.map((data) => {
              const evaporator = data.batteryInfo.find(
                (battery) => battery.type === "Evaporator"
              );
              const condenser = data.batteryInfo.find(
                (battery) => battery.type === "Condenser"
              );
              return {
                ...data,
                evaporatorInfo: evaporator,
                condenserInfo: condenser,
              };
            }),
          ];
        }
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: false,
        });
      }
    },
    showDetail(item) {
      this.showDetailModal = {
        status: true,
        adminDetailStatus: false,
        item: item,
      };
    },
    showAdminDetail(item) {
      this.showDetailModal = {
        status: false,
        adminDetailStatus: true,
        item: item,
      };
    },
    date(value = new Date()) {
      const date = new DateHelper(this.$i18n.locale);
      return date.format(value);
    },
    SET_LOCKED_DESCRIPTION() {
      return this.lockedModal.item.isLocked ? "unlocked" : "locked";
    },
    REMOVE_TO(item) {
      if (!item.isPermission || item.isLocked || !this.hasAuthorize.delete)
        return;

      this.removeModal = {
        status: true,
        item: item,
      };
    },
    async REMOVE_ITEM(loading) {
      loading(true);

      const response = await this.$store.dispatch(this.remove.dispatch, {
        id: this.removeModal.item.id,
      });
      if (response.message === "OK") {
        this.getItemsOfPage();
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`${this.remove.title}.success`),
          variant: "success",
          duration: 2500,
        });
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`${this.remove.title}.error`),
          variant: "danger",
          duration: 2500,
        });
      }
      loading(false);
    },
    LOCKED_TO(item) {
      if (!item.isPermission || !this.hasAuthorize.edit) return;
      this.lockedModal = {
        status: true,
        item: item,
      };
    },
    async LOCKED_ITEM(loading) {
      loading(true);
      const response = await Requests.Project.UpdateLockStatus(
        { params: { id: this.lockedModal.item.id } },
        { isLocked: !this.lockedModal.item.isLocked }
      );
      if (response.message === "OK") {
        this.getItemsOfPage();
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`${this.update.title}.success`),
          variant: "success",
          duration: 2500,
        });
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`${this.update.title}.error`),
          variant: "danger",
          duration: 2500,
        });
      }
      loading(false);
    },
    setQuery() {
      const page = Number(this.$route.query.page);
      const search = this.$route.query.search;
      if (!isNaN(page)) this.page = page;
      if (search) this.search = search;
      this.getItemsOfPage();
    },
    getItemsOfPage() {
      if (!this.hasAuthorize.list) return;
      this.removeModal = { status: false, item: {} };
      this.lockedModal = { status: false, item: {} };
      this.$store.dispatch(this.get.dispatch, {
        query: {
          limit: this.limit,
          page: this.page,
          search: this.search,
          ...this.filter,
          ...this.sort,
          ...this.query,
          mainProjectId: this.mainProjectId,
        },
        force: true,
      });
    },
    setSearch(search) {
      this.search = search;
      this.page = 1;
      this.$router.replace({
        query: { ...this.$route.query, search: this.search, page: 1 },
      });
      this.getItemsOfPage();
    },
    setChangedPage(page) {
      this.$router.replace({
        query: { ...this.$route.query, page: page },
      });
      this.page = page;
      this.getItemsOfPage();
    },
    setFilter(filter) {
      this.page = 1;
      const filterScoped = {
        type: filter.type || "",
        isLocked:
          filter.isLocked == null
            ? ""
            : filter.isLocked
            ? "true"
            : "false" || "",
        userId: filter.user?.id || "",
        batteryId: filter.batteryId?.id || "",
      };
      // remove
      this.filter = filterScoped;
      this.getItemsOfPage(filterScoped);
    },
    async getMainProject() {
      if (!this.mainProjectId) return;
      const response = await this.$store.dispatch("getMainProjectById", {
        id: this.mainProjectId,
      });
      console.log(response, "response");
      if (response.message === "OK") {
        this.mainProject = response.data;
      }
    },
    setHeaders() {
      if (this.tab) {
        this.headers = [
          {
            col: 9,
            sm: 10,
            md: 10,
            lg: 10,
            title: "project.name",
            value: "name",
            sortable: true,
          },
          {
            col: 2,
            sm: 1,
            md: 1,
            lg: 1,
            align: "right",
            title: "common.action",
            value: "action",
          },
        ];
      }
    },
  },
  created() {
    this.setHeaders();
  },
  mounted() {
    this.setQuery();
    this.getMainProject();
  },
};
</script>

<style></style>
